import { Map } from 'immutable';

import baseReducer from 'redux/baseReducer';
import { createSymbols } from 'utils/helpers';

export const {
    EDIT_IN_UI,
    RESET_UI,
    CLEAR_PATCH_VALUES
} = createSymbols([
    'EDIT_IN_UI',
    'RESET_UI',
    'CLEAR_PATCH_VALUES'
]);

const initialState = Map({});

const clearValues = (state) => state.withMutations((prevState) => {
    prevState.deleteIn(['campaign', 'product']).deleteIn(['campaign', 'listing']).deleteIn(['campaign', 'campaign']);
});
const editInUi = (state, { path, value }) => state.setIn(path, value);
const resetUi = (state, { keys = [] }) => {
    if (keys.length) {
        return state.filter((val, key) => {
            return keys.includes(key);
        });
    }

    return initialState;
};

export default baseReducer(initialState, {
    [CLEAR_PATCH_VALUES]: clearValues,
    [EDIT_IN_UI]: editInUi,
    [RESET_UI]: resetUi,
});
